/* eslint-disable @typescript-eslint/no-inferrable-types */
export const sectionSpacing: string = '56px'
